import { create } from "zustand";
import { getMqttTopicsMeta } from "@client/api/endpoints";

interface MetricMetaStore {
  /** O(1) lookup metadata per topic (nickname/unit/decimals/valueType). */
  meta: Map<string, MQTTTopic>;
  /** True když boot fetch proběhl alespoň jednou. */
  loaded: boolean;
  /** Načti všechny topicy + metadata z DB (volat po loginu). */
  load: () => Promise<void>;
  /** Upsert metadata pro topic — volá values store po každém WS batchi. */
  upsert: (topic: MQTTTopic) => void;
  /** Reset (logout). */
  clear: () => void;
}

export const useMetricMetaStore = create<MetricMetaStore>((set, get) => ({
  meta: new Map(),
  loaded: false,

  load: async () => {
    const res = await getMqttTopicsMeta();
    if (!res.success || !res.responseObject) return;
    const next = new Map<string, MQTTTopic>();
    for (const t of res.responseObject) next.set(t.topic, t);
    set({ meta: next, loaded: true });
  },

  upsert: (topic) => {
    const prev = get().meta.get(topic.topic);
    // Skip pokud se metadata nezměnila — vyhne se zbytečnému re-renderu komponent.
    if (
      prev &&
      prev.nickname === topic.nickname &&
      prev.unit === topic.unit &&
      prev.decimals === topic.decimals &&
      prev.valueType === topic.valueType &&
      prev.lastDigitPrecision === topic.lastDigitPrecision
    ) {
      return;
    }
    set((state) => {
      const next = new Map(state.meta);
      next.set(topic.topic, topic);
      return { meta: next };
    });
  },

  clear: () => set({ meta: new Map(), loaded: false }),
}));
